export default "__VITE_ASSET__M_KrvJdh__"